import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService, HttpMethod} from '../../base-api.service';
import {ProductsModelService} from '../../../Models/Purchases/Products/products-model.service';
import {ProductStoreForm} from '../../../../Models/Purchases/Products/product-store.model';
import {SuggestedProductsModelService} from '../../../Models/Purchases/Products/suggested-products-model.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ProductsModelService,
    public suggestedProductsModel: SuggestedProductsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los productos
   *
   */
  public getProducts(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar nuevo producto
   *
   */
  public getProductDetail(params: { id_producto: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProducto', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar nuevo producto
   *
   */
  public setProduct(params: ProductStoreForm): Promise<ApiResponse> {
    const endpoint: string = params.id ? 'products/' + params.id : 'setProducto';
    const formData = params.asFormData();

    if (params.id) {
      formData.append('_method', 'put');
    }

    return new Promise((resolve, reject) => {

      return this.httpCall(endpoint, formData, 'post', !params.id).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });
  }


  /**
   * Eliminar producto
   *
   */
  public deleteProduct(productId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('products/' + productId, {}, 'delete').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los productos sugeridos
   *
   */
  public getSuggestedProducts(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductosSugeridos').subscribe({
        next: (response) => {
          if (save) {
            this.suggestedProductsModel.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los productos con sus locales configurados
   *
   */
  public listAllProducts(params: { wasteable_for_store?: number, stocked_in_store?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('products', params, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener el producto por código
   *
   */
  getProductByCode(params: { codigo: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductoByCodigo', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

}
